export const firebaseConfig = {
   apiKey: "AIzaSyCP4KLDGqhq_jCpfeEoPwu_cd5-eGUtgAE",
   authDomain: "my-project-1557212624954.firebaseapp.com",
   databaseURL: "https://my-project-1557212624954-default-rtdb.asia-southeast1.firebasedatabase.app",
   projectId: "my-project-1557212624954",
   storageBucket: "my-project-1557212624954.appspot.com",
   messagingSenderId: "799570929517",
   appId: "1:799570929517:web:e62a1aa3c1155aa1579c64"
 };